import { render, staticRenderFns } from "./searchGoods.vue?vue&type=template&id=ae538b58&scoped=true"
import script from "./searchGoods.vue?vue&type=script&lang=js"
export * from "./searchGoods.vue?vue&type=script&lang=js"
import style0 from "./searchGoods.vue?vue&type=style&index=0&id=ae538b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae538b58",
  null
  
)

export default component.exports